import { Component } from '@angular/core';

@Component({
  selector: 'tt-oee-menu',
  templateUrl: './oee-menu.component.html',
  styleUrls: ['./oee-menu.component.css'],
  standalone: false,
})
export class OeeMenuComponent {
    public readonly name = 'oeemenu';

}
